import type { CogentActivity } from "@softmax/avatar/character";

import type { CogentLive } from "./chat/chat-view";
import type { CogentWidgetProps } from "./widget-types";

export function doingOf({
  live,
  cogent,
}: {
  live: CogentLive | null;
  cogent: CogentWidgetProps["cogent"];
}) {
  if (!live) return cogent?.doing ?? null;

  return live.status.kind === "awake" ? live.doing : null;
}

export function activityOf({
  live,
  doing,
  busy,
}: {
  live: CogentLive | null;
  doing: string | null;
  busy: boolean;
}): CogentActivity {
  let kind: CogentActivity["kind"] = "idle";
  const pending = live?.messages.at(-1)?.pending;

  if (live?.draft != null) kind = "speaking";
  else if (doing !== null) kind = "working";
  else if (busy || ["sending", "sent", "waiting"].includes(pending ?? ""))
    kind = "thinking";

  return { kind, step: doing, said: live?.draft?.length ?? 0 };
}

/** Only what is happening now: when nothing is, the line goes away. */
export function statusLineOf({
  live,
  doing,
}: {
  live: CogentLive | null;
  doing: string | null;
}) {
  if (live?.question) return "Waiting for your answer";

  if (doing !== null) return doing;

  if (live?.status.kind === "starting") return live.status.label;

  const pending = live?.messages.at(-1)?.pending;

  return pending === "sending" || pending === "waiting" ? "Sending…" : null;
}
